// FieldShowAsProfileStackField.jsx

import React from 'react';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * FieldShowAsProfileStackField
 *
 * Toggle for People fields to render selected people as an overlapping
 * profile photo stack instead of a vertical name list.
 *
 * @returns {ReactNode} The rendered control.
 */
const FieldShowAsProfileStackField = ({
  showAsProfileStack,
  onShowAsProfileStackChange,
}) => (

  <ModalField>

    <ModalLabel label="Display" />
    <ModalHint hint="When enabled, selected people are shown as an overlapping profile photo stack instead of a vertical list." />

    <Checkbox
      value={showAsProfileStack === true}
      size="22"
      label="Show as profile photo stack"
      onChange={() => onShowAsProfileStackChange(!(showAsProfileStack === true))}
    />

  </ModalField>

);

// Dev Tools
FieldShowAsProfileStackField.displayName = 'FieldShowAsProfileStackField';

export default FieldShowAsProfileStackField;
